import { css, html } from "lit";
import "../../atom/Icon/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfLoadingSpinner = class extends BaseComponent {
  render() {
    return html`<dsf-icon dsf_name="Loader2" class="h-auto flex-auto animate-spin"></dsf-icon>`;
  }
};
DsfLoadingSpinner.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfLoadingSpinner.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        /* Default spinner size, color */
        width: calc(2 * var(--dsf-base-size));
        height: calc(2 * var(--dsf-base-size));
        color: rgb(var(--dsf-color-neutral-700));
      }
    `
];
DsfLoadingSpinner = __decorateClass([
  defineElement("dsf-loading-spinner")
], DsfLoadingSpinner);
export {
  DsfLoadingSpinner
};
